import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  enforceMinMax(e) {
    const max = parseFloat(e.target.getAttribute('max'));
    const value = e.target.value;

    if (value && parseFloat(value) > max) {
      e.target.value = max;
    }

    if (value && parseFloat(value) < 1) {
      e.target.value = null;
    }
  }
}
